import { render, staticRenderFns } from "./AlertSimpleTable.vue?vue&type=template&id=74ba690f&scoped=true"
import script from "./AlertSimpleTable.vue?vue&type=script&lang=js"
export * from "./AlertSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./AlertSimpleTable.vue?vue&type=style&index=0&id=74ba690f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba690f",
  null
  
)

export default component.exports